/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled'

const Wrapper = styled.div`
  padding: 16px;
  text-align: center;
`

const VideoStyled = styled.video`
  width: 100%;
  border-radius: 12px;
  margin-bottom: 12px;
  background: #000;
`

const Caption = styled.p`
  font-size: 14px;
  color: #666;
`

export default function AnnouncementVideo({ data }) {
  return (
    <Wrapper>
      <VideoStyled src={data.media_url} controls />
      {data.text_content && <Caption>{data.text_content}</Caption>}
    </Wrapper>
  )
}
